class CurrentMachine extends HTMLElement {
  connectedCallback() {
    const machineController = window.getMachineController?.();
    const state = machineController.getCurrentState();
    this.updateDisplayText(state.brand, state.model);
    subscribe('machine:change', (machineData) => {
      this.updateDisplayText(machineData.brand, machineData.model);
    });
  }

  updateDisplayText(brand, model) {
    const unselectedText = window.machine_translations.select_machine || 'Select a machine';
    const parts = [];
    if (brand) parts.push(brand);
    if (model) parts.push(model);

    if (parts.length > 0) {
      this.textContent = parts.join(' ');
    } else {
      this.textContent = unselectedText;
    }

    this.classList.remove('hidden');
  }
}

customElements.define('current-machine', CurrentMachine);
